// Keep app pricing and cart handling intact; initialize only unselected extras.
(() => {
  const productId = document.currentScript?.dataset.productId;
  const defaults = {
    '2044647047217': [
      ['tcustomizer-field-941914-2044647047217', 'No Cup Lid'],
      ['tcustomizer-field-93700-2044647047217', 'No Bottle Cap']
    ],
    '6653201776689': [
      ['tcustomizer-field-259434-6653201776689', 'No Extra Lid'],
      ['tcustomizer-field-877112-6653201776689', 'No Bottle Cap']
    ]
  }[productId];
  if (!defaults) return;
  const initialized = new Set();
  function initialize() {
    defaults.forEach(([id, value]) => {
      const field = document.getElementById(id);
      if (!field || initialized.has(id)) return;
      if (field.querySelector('label.selected, .tcustomizer__dropdown--has-value')) {
        initialized.add(id);
        return;
      }
      const input = Array.from(field.querySelectorAll('input[type="radio"]')).find(option => option.value === value);
      if (input?.labels[0]) {
        initialized.add(id);
        input.labels[0].click();
      }
    });
    if (initialized.size === defaults.length) observer.disconnect();
  }
  const observer = new MutationObserver(initialize);
  observer.observe(document.getElementById('MainContent'), { childList: true, subtree: true });
  initialize();
})();
